module.exports = "/_next/static/images/profile-0f745e9c6ccef2ead995155ecf629f18.svg";